import { Dispatch } from 'react';
import {
  // getPermissionsErrorAction,
  getUserAction,
  getUserSuccessAction,
  getUserErrorAction,
  UserAction,
  getUserRoleAction,
} from './user-actions';
import {
  getCurrentUser,
  // getUserPermissions,
  GetUserRole,
} from '../../api/user';
// import { ProductPermissions, ProductType } from '../../constants/constants';
export interface UserThunks {
  getCurrentUser(): Promise<void>;
}

// const fetchPermissions = async (
//   dispatch: Dispatch<UserAction>
// ): Promise<ProductPermissions[]> => {
//   try {
//     return await getUserPermissions(ProductType);
//   } catch (error) {
//     dispatch(getPermissionsErrorAction(error));
//     return [];
//   }
// };

const fetchRole = async (
  dispatch: Dispatch<UserAction>,
  employeeId: string
): Promise<any> => {
  try {
    const payload = {
      coworkerId: employeeId,
      menuRequired: false,
      storesRequired: true,
      allStores: true,
    };
    const response = await GetUserRole(payload);
    const role = response?.coworkerProfile?.role;

    const stores =
      response?.storeAssignment?.map((store: any) => ({
        accountingUnitNumber: store.accountingUnitNumber,
        accountingUnitName: store.accountingUnitName,
        addressLine1: store.storeDetails?.addressLine1,
        workPhoneNumber: store.storeDetails?.workPhoneNumber,
        storeType: store.storeDetails?.storeType,
        city: store.storeDetails?.city,
        state: store.storeDetails?.state,
      })) || [];

    const customStore = {
      accountingUnitNumber: '09999',
      accountingUnitName: 'PRODUCT SERVICE MX HOME OFF',
      addressLine1: '5501 HEADQUARTERS DR',
      workPhoneNumber: '9999999999',
      storeType: 'RAC',
      city: 'PLANO',
      state: 'Texas',
    };

    stores.push(customStore);

    return { role, stores };
  } catch (error) {
    dispatch(getUserRoleAction(error as Record<string, any>));
    return { role: null, stores: [] };
  }
};

export const getCurrentUserThunk =
  (dispatch: Dispatch<UserAction>) => async () => {
    try {
      dispatch(getUserAction());

      const currentUser = await getCurrentUser();
      // const permissions = await fetchPermissions(dispatch);
      const { role, stores } = await fetchRole(
        dispatch,
        currentUser.employeeId
      );
      const userData = {
        ...currentUser,
        // permissions,
        role,
        stores,
      };

      dispatch(getUserSuccessAction(userData));
    } catch (error) {
      dispatch(getUserErrorAction(error as Record<string, any>));
    }
  };
